import { forwardRef } from 'react';
import { SelectableCard, SelectableCardGroup } from '@gusto/workbench-formik';
import { CardHeader, Grid, Heading } from '@gusto/workbench';

export const WHAT_TO_USE_KEY = 'WHAT_TO_USE';

export enum WhatToUseValues {
  PAYROLL = 'payroll',
  TIME_AND_ATTENDANCE = 'time',
  HIRING_AND_ONBOARDING = 'hiring',
  EMPLOYEE_BENEFITS = 'benefits',
  TALENT_MANAGEMENT = 'talent',
  INSIGHTS_AND_REPORTING = 'reporting',
}

const WhatToUse = forwardRef<HTMLFieldSetElement>((_, ref) => {
  return (
    <SelectableCardGroup
      ref={ref}
      className="question"
      name="whatToUse"
      id="whatToUse"
      label="What do you want to use Gusto for?"
      helperText="We’ve pre-checked what most people want to learn more about. Select all that apply."
    >
      <Grid rowGap={3} columnGap={2} maxWidth={632} maxWidthMd="100%">
        <SelectableCard type="checkbox" aria-label="Payroll" value={WhatToUseValues.PAYROLL}>
          <CardHeader>
            <Heading className="answer" level={3}>
              Payroll
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="checkbox"
          aria-label="Time + attendance"
          value={WhatToUseValues.TIME_AND_ATTENDANCE}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              Time + attendance
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="checkbox"
          aria-label="Hiring + onboarding"
          value={WhatToUseValues.HIRING_AND_ONBOARDING}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              Hiring + onboarding
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="checkbox"
          aria-label="Employee benefits"
          value={WhatToUseValues.EMPLOYEE_BENEFITS}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              Employee benefits
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="checkbox"
          aria-label="Talent management"
          value={WhatToUseValues.TALENT_MANAGEMENT}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              Talent management
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="checkbox"
          aria-label="Insights + reporting"
          value={WhatToUseValues.INSIGHTS_AND_REPORTING}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              Insights + reporting
            </Heading>
          </CardHeader>
        </SelectableCard>
      </Grid>
    </SelectableCardGroup>
  );
});

export default WhatToUse;
